import { render, staticRenderFns } from "./planProViewWx.vue?vue&type=template&id=33fbb91c&scoped=true&"
import script from "./planProViewWx.vue?vue&type=script&lang=js&"
export * from "./planProViewWx.vue?vue&type=script&lang=js&"
import style0 from "./planProViewWx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./planProViewWx.vue?vue&type=style&index=1&id=33fbb91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbb91c",
  null
  
)

export default component.exports